import React from 'react';

import {twx} from '@/utils/tailwindUtils';

interface AutoDeliveryDcxSectionProps {
    className?: string;
    title?: string | null;
    action?: React.ReactNode;
    children?: React.ReactNode;
}

const AutoDeliveryDcxSection = ({className, title, action, children}: AutoDeliveryDcxSectionProps) => {
    return (
        <div className={twx('p-4 ml:p-0', className)}>
            {title && (
                <div className='flex items-center justify-between gap-2'>
                    <h2 className='mb-0 overflow-hidden text-ellipsis whitespace-nowrap text-20 font-bold leading-[28px] ml:text-primary'>
                        {title}
                    </h2>
                    {action}
                </div>
            )}
            {children}
        </div>
    );
};

export default AutoDeliveryDcxSection;
